import { render, staticRenderFns } from "./product_ungroup.vue?vue&type=template&id=098bdd22&scoped=true"
import script from "./product_ungroup.vue?vue&type=script&lang=js"
export * from "./product_ungroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bdd22",
  null
  
)

export default component.exports